<template>
  <div id="listFooter">
    <vo-empty-state :text="emptyText"></vo-empty-state>
  </div>
</template>

<script>

  export default {
    props: {
      list: {
        type: Object,
        required: true
      }
    },
    computed: {
      emptyText () {
        if (!this.list.items) return '';
        var name = this.list.name || 'items'; 
        return this.list.items.length === 0 ? 'No ' + name : 'No more ' + name;
      }
    }
  }

</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/ListFooter.vue